<template>
  <div>
    <Head />
    <div class="wrap" :class="{miniWrap: platform}">
      <div class="my-order">
        <h2>我的订单</h2>

        <div class="empty-content" v-show="!lists.length">
          <div class="icon"></div>
          <p>您还未购买饷店店铺服务～</p>
          <!-- <div class="shop-btn" @click="goShop">去开店</div> -->
        </div>

        <div class="order-type" v-show="lists.length">
          <ul class="order-detail">
            <li><span>个人版</span><em>方案类型</em></li>
            <li><span>{{expireTime}}</span><em>到期日期</em></li>
            <li><span>{{surplusDay}}天</span><em>剩余日期</em></li>
            <li><span>{{shopStatus}}</span><em>店铺状态</em></li>
          </ul>
          <div class="use-operate">
            <div class="use-market-btn" v-show="!isOutTime" @click="useShop">去使用店铺</div>
            <div class="add-money-btn" v-show="!isOutTime" @click="goShop">去续费</div>
            <div class="add-money-btn outTime" v-show="isOutTime" @click="goShop">去续费</div>
          </div>
        </div>
      </div>

      <div class="order-list" v-show="lists.length">
        <h2>购买记录</h2>
        <i-table :columns="headers" :data="lists"></i-table>
      </div>

    </div>
    <Foot />
    <LoginOut v-show="showLoginOut" />
  </div>
</template>

<script>
import Head from 'components/header'
import Foot from 'components/footer'
import LoginOut from 'components/loginout'
import { mapState, mapMutations } from 'vuex'
import { xdParterOrder, xdParterOrderList } from 'api/http'
export default {
  data() {
    return {
      headers: [
        {
          title: '方案类型',
          key: 'version',
          align: 'center'
        },
        {
          title: '支付日期',
          key: 'payTime',
          align: 'center'
        },
        {
          title: '到期日期',
          key: 'expireTime',
          align: 'center'
        },
        {
          title: '金额',
          key: 'payMoney',
          align: 'center'
        },
        {
          title: '支付方式',
          key: 'payType',
          align: 'center'
        }
      ],
      lists: [],
      expireTime: '1900-01-01',
      surplusDay: '365',
      shopStatus: '已激活',
      isOutTime: false
    }
  },
  created() {
    this.setName(7)
    this.setPlatform()
    this.getParterOrder()
    this.$track.sendLog('pageview', {
      spm: '3.1605'
    })
  },
  components: {
    Head,
    Foot,
    LoginOut
  },
  computed: {
    ...mapState([
      'platform',
      'userInfo',
      'showLoginOut'
    ])
  },
  methods: {
    ...mapMutations(['setName', 'setPlatform']),
    async getParterOrder() {
      let that = this
      let userId = localStorage.getItem('akc_userId')
      let recentOrder = await xdParterOrder({ userId: userId })
      let res = await xdParterOrderList({ userId: userId })
      if(res && res.success) {
        let list = res.data.list
        list.map((v)=> {
          v.version = '个人版'
          v.payMoney = (v.payMoney/100).toFixed(2)
          v.payType = '微信'
        })
        that.lists = res.data.list
      }
      if(recentOrder && recentOrder.success) {
        that.expireTime = recentOrder.data.expireTime.split(' ')[0]
        that.surplusDay = recentOrder.data.surplusDay
      }
    },
    goShop() {
      this.$track.sendLog('click', {
        spm: '3.1605.1970'
      })
      this.$router.push('/shop')
    },
    useShop() {
      this.$track.sendLog('click', {
        spm: '3.1605.1971'
      })
      let url = 'https://console.xiangtuan.xyz/login?loginType=msg'
      window.location.href = url
    }
  }
}
</script>

<style scoped lang="less">
  .wrap {
    width: 100%;
    background: #fff;
    .my-order {
      h2 {
        font-size:24px;
        font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
        font-weight:800;
        color:#2B2E33;
        line-height:33px;
        padding: 52px 0 26px 0;
        text-align: left;
      }
      .empty-content {
        width: 100%;
        height: 409px;
        margin-top: 78px;
        padding-top: 47px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .icon {
          width: 160px;
          height: 160px;
          background-image: url('../common/img/empty.png');
          background-size: 100% 100%;
        }
        p {
          font-size:12px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:17px;
          padding: 1px 0 57px;
        }
        .shop-btn {
          width:140px;
          height:44px;
          background:#EC2232;
          border-radius:2px;
          font-size:14px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(255,255,255,1);
          line-height:44px;
          &:hover {
            background:#FC3142;
          }
        }
      }
      .order-type {
        width:1000px;
        height:167px;
        background:rgba(250,250,250,1);
        padding: 35px 90px 35px 35px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        ul {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 872px;
          li {
            width: 186px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            span {
              font-size:20px;
              font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
              font-weight:800;
              color:#333;
              line-height:28px;
            }
            em {
              font-size:12px;
              font-family:PingFangSC-Regular;
              font-weight:400;
              color:#999;
              line-height:17px;
              font-style: normal;
              margin-top: 10px;
            }
            &::after {
              content: '';
              position: absolute;
              right: 0;
              top: 17px;
              height: 22px;
              overflow: hidden;
              border-right: solid 1px #ccc;
            }
            &:last-child::after {
              display: none;
            }
          }
        }
        .use-operate {
          .use-market-btn {
            width:120px;
            height:44px;
            background:#EC2232;
            border-radius:2px;
            font-size:14px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            line-height: 44px;
            color: #fff;
            cursor: pointer;
            &:hover {
              background: #FC3142;
            }
          }
          .add-money-btn {
            margin-top: 10px;
            width:120px;
            height:44px;
            border-radius:2px;
            border:1px solid rgba(236,34,50,1);
            font-size:14px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(236,34,50,1);
            line-height: 44px;
            cursor: pointer;
          }
          .outTime {
            background: #EC2232;
            color: #fff;
            border: none;
            margin: 0;
            &:hover {
              background: #FC3142;
            }
          }
        }
      }
    }
    .order-list {
      h2 {
        font-size:24px;
        font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
        font-weight:800;
        color:#2B2E33;
        line-height:33px;
        padding: 52px 0 26px 0;
        text-align: left;
      }
    }
  }
</style>
